module.exports = __webpack_public_path__ + "img/pleasantly_v2.cadfaa8.png";